import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { sessionPassiveGuard } from '@smartera/core';
import { ExpirePasswordComponent } from './expire-password/expire-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login.component';
import { RegisterExpiredComponent } from './register-expired/register-expired.component';
import { RegisterPasswordComponent } from './register-password/register-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
	{
		path: 'login',
		canMatch: [sessionPassiveGuard],
		component: LoginComponent,
	},
	// { path: 'login/forgot-password', component: ForgotPasswordComponent },
	{ path: 'login/expire-password/:email', component: ExpirePasswordComponent },
	{ path: 'login/register-password', component: RegisterPasswordComponent },
	{
		path: 'login/register/:email/:activation',
		component: RegisterPasswordComponent,
		data: { pageTitle: 'User Activation', loginType: 'registerPassword' },
	},
	{
		path: 'login/register/:email/:activation/expired',
		component: RegisterExpiredComponent,
	},
	{
		path: 'login/reset-password/:email/:activation',
		component: ResetPasswordComponent,
		data: { pageTitle: 'Reset Password', loginType: 'resetPassword' },
	},
	{ path: '', redirectTo: '/login', pathMatch: 'full' },
];
@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class LoginRoutingModule {}
